<template>
  <div style="background-color: #edf4fc;">
    <div style="overflow: hidden;">
      <div style="height: 3.8rem;">

        <el-carousel style="background-color: #fdcc4e;width: 75%;float: left;height: 3.8rem;">
          <el-carousel-item v-for="Picture in Pictures" :key="Picture.id" style="height: 3.8rem;">
            <a :href="Picture.link" target="_blank">
              <el-image :src="Picture.picture" style="height: 3.2rem;width: 100%;">
                <div slot="error" v-loading="loading"></div>
              </el-image>
              <p style="text-align: center;font-size: 30px;font-weight: 700;margin: 0;">{{ Picture.name }}</p>
            </a>
          </el-carousel-item>
        </el-carousel>

        <div style="width: 24%;float: left;padding: 0.5%;">
          <div class="news">最新资讯</div>
          <div v-for="item in informationData" :key="item.id" class="divcolor">
            <a :href="item.link" class="cell-link" target="_blank">{{ item.filename }}</a>
          </div>
        </div>
      </div>

      <div>
        <el-row>
          <el-col :span="6">
            <a href="javascript:void(0)" @click="managerBlank('/journal')">
              <div class="label-col divcolor">
                <span style="float: left;">期刊专著</span>
                <i class="el-icon-right" style="float: right;margin-top: 6px;"></i>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0)" @click="managerBlank('/celebrity')">
              <div class="label-col divcolor">
                <span style="float: left;">名人录</span>
                <i class="el-icon-right" style="float: right;margin-top: 6px;"></i>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0)" @click="managerBlank('/introduction')">
              <div class="label-col divcolor">
                <span style="float: left;">管理类硕士简介</span>
                <i class="el-icon-right" style="float: right;margin-top: 6px;"></i>
              </div>
            </a>
          </el-col>
          <el-col :span="6">
            <a href="javascript:void(0)" @click="managerBlank('/major')">
              <div class="label-col divcolor">
                <span style="float: left;">考研专业目录</span>
                <i class="el-icon-right" style="float: right;margin-top: 6px;"></i>
              </div>
            </a>
          </el-col>
        </el-row>
      </div>

      <div style="overflow: hidden;">
        <div style="width: 75%;float: left;">
          <div style="height: 0.5rem;">
            <div class="news" style="padding-left: 0.1rem;float: left;">宣讲会</div>
            <div style="background-color: #edf4fc;float: right;padding-top: 0.1rem;">
              <el-pagination :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
            </div>
          </div>
          <el-row>
            <el-col :span="8" v-for="item in Lectures" :key="item.id" style="padding: 0.15rem;">
              <a :href="item.link" target="_blank">
                <el-image :src="item.lecture" style="height: 1.5rem;width: 100%;border-radius: 5px;">
                  <div slot="error" v-loading="loading"></div>
                </el-image>
                <p style="text-align: left;font-size: 18px;font-weight: 700;margin: 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</p>
                <p style="text-align: left;font-size: 18px;font-weight: 700;margin: 0;">{{ item.time }}</p>
              </a>
            </el-col>
          </el-row>
        </div>
        <div style="width: 24%;float: right;padding: 0.5%;">
          <div class="news">最新资料</div>
          <div v-for="item in fileData" :key="item.id" class="divcolor">
            <a v-if="item.link === ''" href="javascript:void(0);" class="cell-link" @click="onUploadData(item)">{{ item.filename }}</a>
            <a v-if="item.link !== ''" :href="item.link" class="cell-link" target="_blank">{{ item.filename }}</a>
          </div>
        </div>
      </div>

      <div>
        <div style="overflow: hidden;">
          <div class="news" style="padding-left: 0.1rem;float: left;">国际项目</div>
          <a
            href="javascript:void(0)"
            @click="managerBlank('/nation')"
            class="nation-color"
            style="float: right;padding-top: 0.1rem;padding-right: 0.2rem;font-size: 18px;font-weight: 700;"
          >
            更多
          </a>
        </div>
        <el-row>
          <el-col :span="6" v-for="item in Nations" :key="item.id" style="padding: 0.15rem;">
            <a :href="item.link" target="_blank">
              <el-image :src="item.picture" style="height: 1.5rem;width: 100%;border-radius: 5px;">
                <div slot="error" v-loading="loading"></div>
              </el-image>
              <p style="text-align: left;font-size: 18px;font-weight: 700;margin: 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</p>
              <p style="text-align: left;font-size: 18px;font-weight: 700;margin: 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.major }}</p>
            </a>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectPicture } from '@/api/homeAPI'
import { selectDataDownload, filesDownloadById } from '@/api/datadownloadAPI'
import { selectLecture } from '@/api/homeLectureAPI'
import { SelectInformation } from '@/api/informationAPI'
import { selectNation } from '@/api/nationAPI'

export default {
  name: 'Home',
  data() {
    return {
      Pictures: [],
      loading: true,
      fileData: [],
      informationData: [],
      Lectures: [],
      Nations: [],
      currentPage: 1,
      pageSize: 6,
      total: 1
    }
  },
  created() {
    this.selectPictures()
    this.selectDataFind()
    this.selectInformationDataFind()
    this.selectLectures()
    this.selectNations()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async selectPictures() {
      const { data: res } = await selectPicture()
      this.Pictures = res.data
    },
    async selectDataFind() {
      const { data: res } = await selectDataDownload('全部', '全部', 20, 1, 12)
      this.fileData = res.data[2]
    },
    async selectInformationDataFind() {
      const { data: res } = await SelectInformation('全部', '全部', 20, '全部', 1, 9)
      this.informationData = res.data[2]
    },
    async selectLectures() {
      const { data: res } = await selectLecture(this.currentPage, this.pageSize)
      this.Lectures = res.data[2]
      this.total = res.data[0]
    },
    async selectNations() {
      const { data: res } = await selectNation(1, 4)
      this.Nations = res.data[2]
    },
    async onUploadData(item) {
      const { data: res } = await filesDownloadById(item.id)
      // 下载文件
      const blob = new Blob([res])
      const objectUrl = URL.createObjectURL(blob) // 创建URL
      const link = document.createElement('a')
      link.href = objectUrl
      // 这里是获取后台传过来的文件名
      link.setAttribute('download', item.filename)
      link.click() // 下载文件
      URL.revokeObjectURL(objectUrl) // 释放内存
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      const { data: res } = await selectLecture(this.currentPage, this.pageSize)
      this.Lectures = res.data[2]
      this.total = res.data[0]
    },
    managerBlank (address) {
      const routeData = this.$router.resolve({ path: address })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.divcolor:hover {
  background-color: #B8860B;
}
.nation-color:hover {
  color: #B8860B;
}
a p {
  padding: 5px;
}
a p:hover {
  background-color: #B8860B;
  border-radius: 3px;
  color: #000;
}
.label-col {
  height: 40px;
  color: #fff;
  background-color: #3a2b05;
  font-size: 27px;
  padding: 15px;
  margin: 20px;
  border-radius: 6px;
}
.label-col a:hover {
  background-color: #ffffff;
}
.news {
  margin: 0.1rem 0.1rem 0.1rem 0.05rem;
  font-size: 25px;
  font-weight: 700;
}
.cell-link {
  display: inline-block;
  font-size: 19px;
  width: 100%;
  padding: 0.066rem 0 0.066rem 0.05rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.lecture-col {
  margin: 0.15rem;
}
.el-button {
  padding: 0.08rem 0.08rem;
}
/deep/ .el-carousel__arrow--left{
  background-color: #ffb700;
  margin-top: 0.7rem;
}
/deep/ .el-carousel__arrow--right{
  background-color: #ffb700;
  margin-top: 0.7rem;
}
/deep/ .el-carousel__indicator--horizontal .el-carousel__button {
  background-color: #fff;
}
/deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button{
  background-color: red;
}
</style>
